import { action } from 'typesafe-actions';

import type {
  GetListedItemsRequestData,
  ListedItemsListViewPage,
} from '@payaca/types/listedItemTypes';
import { ActionType } from './listedItemsTypes';

export const requestGetListedItemsPage = (
  getListedItemsRequestData: GetListedItemsRequestData
) => {
  return action(ActionType.REQUEST_GET_LISTED_ITEMS_PAGE, {
    getListedItemsRequestData,
  });
};

export const clearListedItemsPage = () => {
  return action(ActionType.CLEAR_LISTED_ITEMS_PAGE);
};

export const getListedItemsPageSuccess = (
  listedItemsPage: ListedItemsListViewPage
) => {
  return action(ActionType.GET_LISTED_ITEMS_PAGE_SUCCESS, {
    listedItemsPage,
  });
};

export const getListedItemsPageFailure = (error: Error) => {
  return action(ActionType.GET_LISTED_ITEMS_PAGE_FAILURE, null, null, error);
};
